const getApplications = (state) => {
  return state.applications
}
const getContextMenu = (state) => {
  return state.contextMenu
}
const getContextMenuState = (state) => {
  return state.contextMenuOpened
}
const getMarkerIndex = (state) => {
  return state.markerIndexCount
}

export default {
  getApplications,
  getContextMenu,
  getContextMenuState,
  getMarkerIndex
}
